import React, { useState } from 'react';
import { ServiceSubStep } from '../service-step.types';
import { ServiceCentreSelection } from '../service-centre-selection/service-centre-selection';
import { DeliveryServiceSelection } from '../delivery-service-selection/delivery-service-selection';
import { SpecificServiceSelection } from '../specific-service-selection/specific-service-selection';
import { useOSBContentFragment } from '../../../../../hooks/owners-osb/aem-content-util/use-osb-content-fragment';
import { DealerProfileInfo } from '../../../../../models/osb-model/osb-dealer-info';
import { FMButton } from '@own/fds-react';

export const ServiceStepHandler = () => {
    const serviceContent =
        useOSBContentFragment('common/osb-v3', 'service-step') || {};
    const [selectedDealer] = useState<DealerProfileInfo | null>({
        dealerCode: '46396AA',
        dealerName: 'Ford of Northlake',
        street: '4100 Northlake Pkwy',
        town: 'Northlake',
        postalCode: '98078',
        delivery: ['Standard Home Delivery', 'Pickup at Dealer'],
        openingHours: {
            monday: '08:30-18:00',
            tuesday: '08:30-18:00',
            wednesday: '08:30-18:00',
            thursday: '08:30-20:00',
            friday: '08:30-18:00',
            saturday: '09:00-16:00',
            sunday: 'Closed',
        },
        customerRating: 4.7,
        customerRespondentsService: 214,
        distance: 7.6,
        primaryPhone: '+1-425-555-0199',
        location: { lat: 47.7805, lng: -122.2066 },
        dealerType: 'Authorized Dealer',
        additionalInfo: {
            earliestAvailableTimeslot: '2025-11-26T09:00:00-08:00',
            dealerFilterServiceAvailability: [
                { filterKey: 'test-drive' },
                { filterKey: 'oil-change' },
            ],
            nextAppointmentDateAm: '2025-11-27',
            nextAppointmentDatePm: '2025-11-28',
            nextAppointmentDateWeekend: '2025-11-29',
        },
        specialServices: ['Mobility Scooter Pickup', 'Vehicle Trade-In'],
        didVideoCheck: true,
        didMobileService: true,
        dealerGroup: 'Ford Direct',
        serviceDepartmentCV: true,
        serviceDepartmentPV: false,
        electricService: true,
    });

    const [currentSubStep, setCurrentSubStep] = useState<ServiceSubStep>(
        ServiceSubStep.ServiceCentreSelection
    );
    const handleNextClick = () => {
        if (selectedDealer) {
            setCurrentSubStep(ServiceSubStep.DeliveryServiceSelection);
        }
    };
    const renderSubStep = () => {
        switch (currentSubStep) {
            case ServiceSubStep.ServiceCentreSelection:
                return <ServiceCentreSelection />;

            case ServiceSubStep.DeliveryServiceSelection:
                if (!selectedDealer) {
                    return <div>Error: No dealer selected.</div>;
                }

                return (
                    <DeliveryServiceSelection
                        dealer={selectedDealer}
                        contentData={serviceContent}
                        onNext={selectedServiceId => {
                            console.log(
                                'Selected Delivery ID:',
                                selectedServiceId
                            );

                            setCurrentSubStep(
                                ServiceSubStep.SpecificServiceSelection
                            );
                        }}
                        onBack={() =>
                            setCurrentSubStep(
                                ServiceSubStep.ServiceCentreSelection
                            )
                        }
                    />
                );

            case ServiceSubStep.SpecificServiceSelection:
                return (
                    <SpecificServiceSelection
                        onBack={() =>
                            setCurrentSubStep(
                                ServiceSubStep.DeliveryServiceSelection
                            )
                        }
                    />
                );

            default:
                return <ServiceCentreSelection />;
        }
    };

    return (
        <div>
            {renderSubStep()}
            <div style={{ marginTop: '20px', textAlign: 'right' }}>
                <FMButton
                    data-testid="preferred-dealer-button"
                    className="osb-v3-search-service-centre-button"
                    onClick={handleNextClick}
                    label="<>"
                    theme="light"
                    htmlButtonType="button"
                    type="primary"
                />
            </div>
        </div>
    );
};
